import { SponsorList } from "./sponsor-list";

export class Sponsor extends SponsorList{
    id: string;
    contactEmail: string;
    outingIterationId: string;
    lastEditedBy: string;
    createdBy: string;
}
